import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { FONT } from '@constants/style';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: '#404348',
      height: '100%',
      color: '#f8f9fb',
      lineHeight: '18px',
      fontSize: '14px',
      paddingTop: 0,
      '& .main-item-icon': {
        color: '#FFFFFF',
        minWidth: '0',
        paddingRight: '8px'
      },
      '& > button:hover': {
        backgroundColor: '#4c4f56',
        '& .main-item-icon': {
          color: FONT.COLOR.PRIMARY.LIGHT
        }
      },
        
    },
    mainListItem: {
      textTransform: 'uppercase',
      fontWeight: FONT.WEIGHT.MEDIUM,
      paddingLeft: '20px',
      paddingTop: '12px',
      paddingBottom: '12px',
    },
    listItemOpened: {
      backgroundColor: '#2e3034',
      '& .main-item-icon': {
        color: FONT.COLOR.PRIMARY.LIGHT
      }
    },
    subGroup: {
      backgroundColor: '#2e3034',
    },
    subListHeader: {
      color: FONT.COLOR.PRIMARY.LIGHT,
      textTransform: 'uppercase',
      fontWeight: FONT.WEIGHT.REGULAR,
      borderBottom: '2px solid #5c5c5c',
      backgroundColor: '#2e3034',
      fontSize: '12px',
      lineHeight: '16px',
      paddingTop: '12px',
      paddingBottom: '12px',
      paddingLeft: '20px',
    },
    subListItem: {
      paddingLeft: '52px',
      paddingTop: '12px',
      paddingBottom: '12px',
      textTransform: 'capitalize',
      fontWeight: FONT.WEIGHT.REGULAR,
      backgroundColor: '#2e3034',
    },
    listItemActive: {
      backgroundColor: '#4c4f56',
      color: '#FFFFFF',
      fontWeight: FONT.WEIGHT.MEDIUM,
    },
  }),
);

export default useStyles;